import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-shared-card",
  templateUrl: "./shared-card.component.html",
  styleUrls: ["./shared-card.component.css"],
})
export class SharedCardComponent implements OnInit {
  @Input() curso: any;

  @Output() openModalEmitter = new EventEmitter<any>();
  formattedDate: string | null = "";
  truncatedDescripcion: string | undefined;

  constructor() {}

  ngOnInit() {
    this.truncatedDescripcion = this.truncateDescription(
      this.curso.Description,
      170
    );
  }

  // Función para truncar la descripción
  truncateDescription(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  openModal() {
    this.openModalEmitter.emit(this.curso);
  }
}
